<template>
    <section class="calendar-event announcement" @click="pushRouter" v-tooltip="getTooltip">
        <span class="calendar-event--name">
            {{ event.name }}
        </span>
    </section>
</template>
<script charset="utf-8">
    export default{
        name: "CalendarEventAnnouncement",
        props:{
            event: {
                type: Object
            }
        },
        computed:{
            getTooltip() {
                const go_to = this.$t('com.file.calendar-event-announcement.go-to-announcement');
                return `${go_to} ${this.event.name}`
            }
        },
        methods:{
            async pushRouter(){
                await this.$router.push(this.event.router);
            }
        }
    }
</script>
<style lang="scss" scoped>
@use "@/assets/scss/calendar-event.scss";

.announcement{
    background: rgba(0, 77, 204, 0.6);
    color: #fff;
    &:hover{
        background: rgba(0, 77, 204, 1);
    }
}
</style>